// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/quest_bg_idle.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questCardContainer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  width: 280px;
  height: 74px;
  position: relative;
  display: flex;
  align-items: center;
}

.questInfoContainer {
  position: absolute;
  left: 94px;
  display: flex;
  flex-direction: column;
}

.questInfoContainer span,
p {
  font-size: 10px;
  color: #ffffff;
  margin: 0;
}

.questInfoContainer .fireSpells {
  font-size: 12px;
  font-weight: 700;
}

.questInfoContainer .questGold {
  color: #ffa600;
}

.questInfoContainer .questExp {
  color: #49d7d8;
}

.completion {
  background-size: 100% 100%;
  width: 48px;
  height: 48px;
  position: absolute;
  right: 8px;
}

.chartContainer {
  position: absolute;
  right: 8px;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1c1f25;
}

.chartContainer svg {
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: visible;
}

.chartContainer svg circle {
  fill: rgba(0, 0, 0, 0);
  stroke-width: 31.8309886184;
  stroke-dasharray: 0, 0, 0, 100;
  stroke-dashoffset: 25;
  animation: pie-chart 6s ease both;
}
.pie-chart {
  stroke: hsl(180, 65%, 57%);
}

/* @keyframes pie-chart {
  50%,
  100% {
    stroke-dasharray: 45, 55, 0, 0;
  }
} */

.chartVal {
  width: 36px;
  height: 36px;
  border: 1px solid #49d7d8;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #252b36;
  z-index: 1;
}

.chartVal span {
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/components/questCard/QuestCard.style.css"],"names":[],"mappings":"AAAA;EACE,yDAAkD;EAClD,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;;AAEA;;;;;GAKG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".questCardContainer {\n  background-image: url(\"@assets/quest_bg_idle.png\");\n  background-size: 100% 100%;\n  width: 280px;\n  height: 74px;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.questInfoContainer {\n  position: absolute;\n  left: 94px;\n  display: flex;\n  flex-direction: column;\n}\n\n.questInfoContainer span,\np {\n  font-size: 10px;\n  color: #ffffff;\n  margin: 0;\n}\n\n.questInfoContainer .fireSpells {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.questInfoContainer .questGold {\n  color: #ffa600;\n}\n\n.questInfoContainer .questExp {\n  color: #49d7d8;\n}\n\n.completion {\n  background-size: 100% 100%;\n  width: 48px;\n  height: 48px;\n  position: absolute;\n  right: 8px;\n}\n\n.chartContainer {\n  position: absolute;\n  right: 8px;\n  height: 48px;\n  width: 48px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #1c1f25;\n}\n\n.chartContainer svg {\n  display: block;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: visible;\n}\n\n.chartContainer svg circle {\n  fill: rgba(0, 0, 0, 0);\n  stroke-width: 31.8309886184;\n  stroke-dasharray: 0, 0, 0, 100;\n  stroke-dashoffset: 25;\n  animation: pie-chart 6s ease both;\n}\n.pie-chart {\n  stroke: hsl(180, 65%, 57%);\n}\n\n/* @keyframes pie-chart {\n  50%,\n  100% {\n    stroke-dasharray: 45, 55, 0, 0;\n  }\n} */\n\n.chartVal {\n  width: 36px;\n  height: 36px;\n  border: 1px solid #49d7d8;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #252b36;\n  z-index: 1;\n}\n\n.chartVal span {\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
